export default __webpack_public_path__ + "static/media/timesquare_by_night.10104de4.jpg";